<div class="dropdown-facet">
  <button mat-flat-button small [matMenuTriggerFor]="dropdown" class="dropdown-facet-button">
    <span class="selected-options-label">{{ selectedLabel }}</span>
    <span class="sif sif-chevron-s"></span>
  </button>
  <mat-menu #dropdown="matMenu">
    <div class="dropdown-filter-menu">
      <h4 class="menu-title">{{ itemsTitle }}</h4>
      <ng-container
        *ngTemplateOutlet="
          itemsTemplate ? itemsTemplate : defaultItemsTemplate;
          context: { outletContext: outletContext }
        "
      ></ng-container>
    </div>
  </mat-menu>
</div>

<ng-template #defaultItemsTemplate let-outletContext="outletContext">
  <div class="content">
    <ng-container
      *ngTemplateOutlet="
        selectAllTemplate ? selectAllTemplate : defaultSelectAllTemplate;
        context: { outletContext: outletContext }
      "
    ></ng-container>
    <ul class="dropdown-menu-sublist">
      @for (item of outletContext.items; track item; let i = $index) {
      <li class="list-item">
        <ng-container
          *ngTemplateOutlet="
            itemTemplate ? itemTemplate : defaultItemTemplate;
            context: { item: item, index: i, outletContext: outletContext }
          "
        ></ng-container>
      </li>
      }
    </ul>
  </div>
</ng-template>

<ng-template #defaultItemTemplate let-item="item" let-outletContext="outletContext">
  <mat-checkbox
    flat
    [label]="item.label"
    [value]="item.value"
    [checked]="item.selected"
    (change)="outletContext.toggleSelection($event)"
    (click)="itemClickHandler($event)"
    #itemElements
  >
    {{ item.label }}
  </mat-checkbox>
</ng-template>

<ng-template #defaultSelectAllTemplate let-outletContext="outletContext">
  <ul class="dropdown-menu-list">
    <li class="list-item">
      <mat-checkbox
        id="selectAll"
        flat
        (change)="outletContext.selectAll(selectAllElement.checked)"
        [checked]="outletContext.allSelected"
        (click)="itemClickHandler($event)"
        #selectAllElement
        >Select All
      </mat-checkbox>
    </li>
  </ul>
</ng-template>
